<nav class="sidebar-container">
  <div class="flex justify-center py-2"><img class="w-[60%] p-4" src="../../../../assets/aisslo-white.webp" alt="Logo">
  </div>
  <div class="sidebar-list">
    <app-sidebar-item *ngFor="let item of menuItems" [item]="item" (onClick)="navigateTo($event)" class="app-sidebar-item"></app-sidebar-item>  
  </div>
</nav>
